<template>
    <div class="public_container invoice_details_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <div class="form_module_title">订单信息</div>
            <div class="form_module_content">
                <p>
                    关联订单：<span class="link-label">{{ invoiceDetails.order_info.order_no }}</span>
                </p>
                <div class="mobile_detail_head_user_wrap">
                    客户联系人：
                    <div
                        class="mobile_detail_head_user"
                        v-if="invoiceDetails.order_info.contact_info"
                        @click="handleClickUserInfo(invoiceDetails.order_info.contact_info)"
                    >
                        <img
                            :src="
                                invoiceDetails.order_info.contact_info.avatar
                                    ? invoiceDetails.order_info.contact_info.avatar
                                    : defaultImg
                            "
                            alt=""
                        />
                        <span class="ellipsis">{{
                            invoiceDetails.order_info.contact_info && invoiceDetails.order_info.contact_info.name
                        }}</span>
                    </div>
                </div>
            </div>
            <template>
                <div class="form_module_title">订单金额信息</div>
                <div class="form_module_content">
                    <p>订单总金额：{{ invoiceDetails.order_info.total_price }}</p>
                    <p>已回款金额：{{ invoiceDetails.order_info.total_repay_price }}</p>
                    <p>待回款金额：{{ invoiceDetails.order_info.no_repay_price }}</p>
                    <p>实际回款金额：{{ invoiceDetails.order_info.repay_price }}</p>
                </div>
            </template>
            <div class="form_module_title">开票申请信息</div>
            <div class="form_module_content">
                <p>开票公司：{{ invoiceDetails.invoice_info.invoice_company_name }}</p>
                <p>发票类型：{{ invoiceDetails.invoice_info.invoice_type_name }}</p>
                <p
                    v-if="
                        invoiceDetails.invoice_info.invoice_type === 1 || invoiceDetails.invoice_info.invoice_type === 2
                    "
                >
                    电子发票提供方式：{{ invoiceDetails.invoice_info.invoice_method_name || "--" }}
                </p>
                <p
                    v-if="
                        invoiceDetails.invoice_info.invoice_type === 1 || invoiceDetails.invoice_info.invoice_type === 2
                    "
                >
                    电子收票邮箱：{{ invoiceDetails.invoice_info.invoice_email || "--" }}
                </p>
                <p>本次开票金额：{{ invoiceDetails.invoice_info.invoice_amount }}</p>
                <p>开票对象：{{ invoiceDetails.invoice_info.invoice_title_type_name }}</p>
                <p class="mb_4">开票信息：</p>
                <div class="invoice_info_text" v-html="invoiceDetails.invoice_info.invoice_info"></div>
                <template
                    v-if="
                        invoiceDetails.invoice_info.invoice_type === 3 || invoiceDetails.invoice_info.invoice_type === 4
                    "
                >
                    <p>
                        收货人：{{
                            invoiceDetails.invoice_info.receive_name ? invoiceDetails.invoice_info.receive_name : "--"
                        }}
                    </p>
                    <p>
                        收货人电话：{{
                            invoiceDetails.invoice_info.receive_phone ? invoiceDetails.invoice_info.receive_phone : "--"
                        }}
                    </p>
                    <p>
                        收货地址：{{
                            invoiceDetails.invoice_info.receive_addr ? invoiceDetails.invoice_info.receive_addr : "--"
                        }}
                    </p>
                </template>
                <div>
                    <p class="mb_4">备注:</p>
                    <p>{{ invoiceDetails.invoice_info.remark }}</p>
                </div>
                <p>附件：</p>
                <div
                    class="file_upload_wrap file_upload_detail_wrap"
                    v-if="
                        invoiceDetails.invoice_info.attachments &&
                        invoiceDetails.invoice_info.attachments.length
                    "
                >
                    <ul class="upload_file_list upload_file_list_detail">
                        <li
                            v-for="(file, fileIndex) in invoiceDetails.invoice_info.attachments"
                            class="upload_file_item"
                        >
                            <div class="file_left_wrap">
                                <img
                                    alt=""
                                    class="file_img"
                                    src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                />
                                <div class="file_info_wrap">
                                    <p class="file_name" v-text="file.file_name"></p>
                                    <p class="file_size" v-text="file.file_size"></p>
                                </div>
                            </div>
                            <div class="file_right_wrap">
                                <el-tooltip content="预览" effect="dark" placement="top">
                                    <span
                                        class="handle_icon_wrap"
                                        @click="
                                            handleClickPreview(
                                                fileIndex,
                                                file,
                                                invoiceDetails.invoice_info.attachments
                                            )
                                        "
                                    >
                                        <i class="iconfont icon-yanjing"></i>
                                    </span>
                                </el-tooltip>
                                <span class="line"></span>
                                <el-tooltip content="下载" effect="dark" placement="top">
                                    <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                        <i class="iconfont icon-daochu"></i>
                                    </span>
                                </el-tooltip>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <template v-if="status == 2">
                <div class="form_module_title">确认开票信息</div>
                <div class="form_module_content">
                    <p>发票号码：{{ invoiceDetails.invoice_info.invoice_number }}</p>
                    <p>已开票金额：{{ invoiceDetails.invoice_info.invoice_amount }}</p>
                </div>
            </template>
            <template v-if="status == 2">
                <div class="form_module_title">其他信息</div>
                <div class="form_module_content">
                    <div>
                        <p class="mb_4">财务备注：</p>
                        <p>{{ invoiceDetails.invoice_info.finance_remark }}</p>
                    </div>
                    <div>
                        <p>附件：</p>
                        <div
                            class="file_upload_wrap file_upload_detail_wrap"
                            v-if="
                                invoiceDetails.invoice_info.finance_attachments &&
                                invoiceDetails.invoice_info.finance_attachments.length
                            "
                        >
                            <ul class="upload_file_list upload_file_list_detail">
                                <li
                                    v-for="(file, fileIndex) in invoiceDetails.invoice_info.finance_attachments"
                                    class="upload_file_item"
                                >
                                    <div class="file_left_wrap">
                                        <img
                                            alt=""
                                            class="file_img"
                                            src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                        />
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览" effect="dark" placement="top">
                                            <span
                                                class="handle_icon_wrap"
                                                @click="
                                                    handleClickPreview(
                                                        fileIndex,
                                                        file,
                                                        invoiceDetails.invoice_info.finance_attachments
                                                    )
                                                "
                                            >
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="下载" effect="dark" placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                                <i class="iconfont icon-daochu"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="status == 3">
                <div class="form_module_title">其他信息</div>
                <div class="form_module_content" v-if="invoiceDetails.invoice_info.status == 4">
                    <p>作废时间：{{ invoiceDetails.other_info.invalid_time }}</p>
                    <div>
                        <p class="mb_4">作废原因：</p>
                        <p>{{ invoiceDetails.other_info.invalid_reason }}</p>
                    </div>
                </div>
                <div class="form_module_content" v-else>
                    <p>驳回时间：{{ invoiceDetails.other_info.reject_time }}</p>
                    <div>
                        <p class="mb_4">驳回原因：</p>
                        <p>{{ invoiceDetails.other_info.reject_reason }}</p>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import { InvoiceDetail, InvoiceExceptionDetail } from "@/api";
import { ImagePreview } from "vant";
import { getOSSData } from "@/utils/uploadOss";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "InvoiceDetails",
    components: { ReturnNavBar },
    data() {
        return {
            invoice_no: "",
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            status: "", // 1:待开票,2:已开票,3:异常开票,4:未开票
            invoiceDetails: {
                order_info: {}, // 订单信息
                invoice_info: {}, // 开票信息
                other_info: {}, // 其它信息
            },
        };
    },
    created() {
        if (this.$route.query) {
            this.invoice_no = this.$route.query.invoice_no;
            this.status = this.$route.query.status;
            if (this.status == 3) {
                this.getInvoiceExceptionDetail();
            } else {
                this.getInvoiceDetail();
            }
        }
    },
    methods: {
        // 详情
        getInvoiceDetail() {
            InvoiceDetail({ invoice_no: this.invoice_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.invoiceDetails = data;
                }
            });
        },
        // 异常开票详情
        getInvoiceExceptionDetail() {
            InvoiceExceptionDetail({ invoice_no: this.invoice_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.invoiceDetails = data;
                }
            });
        },
        //附件预览事件
        handleClickPreview(fileIndex, file, allFile) {
            if (file.file_type.includes("image")) {
                // this.previewImgList = [file.file_path];
                // this.previewImgSrc = file.file_path;
                // this.$refs.preview_img.showViewer = true;
                this.handleClickPreviewImg(
                    fileIndex,
                    allFile.map((item) => item.file_path)
                );
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        // 图片预览
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.ml_10 {
    margin-left: 10px;
}

.invoice_details_wrap {
    background: rgba(255, 255, 255, 1);

    .mobile_container {
        background: rgba(255, 255, 255, 1);

        .form_module_title {
            font-weight: 700;
            font-size: 14px;
            line-height: 24px;
            color: #333333;
            padding: 10px 16px 10px 28px;
            position: relative;

            &::before {
                content: "";
                width: 4px;
                height: 22px;
                opacity: 1;
                border-radius: 20px;
                background: #2990ff;
                position: absolute;
                left: 16px;
            }
        }

        .form_module_content {
            padding: 0 16px;

            & > p,
            & > div {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                margin-bottom: 8px;
            }

            .mb_4 {
                margin-bottom: 4px;
            }
        }

        .voucher_list {
            margin-top: 10px;
            padding: 0;
            display: flex;
            gap: 8px;

            .voucher_item {
                width: 44px;
                height: 44px;
                cursor: pointer;
                position: relative;
                text-align: center;
                line-height: 44px;
                border-radius: 4px;

                .van-image {
                    max-width: 100%;
                    max-height: 100%;
                }

                img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                }

                .icon-guanbi_dise {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    cursor: pointer;
                    font-size: 16px;
                    color: rgba(191, 191, 191, 1);
                    line-height: 16px;
                }
            }
        }

        .invoice_info_text {
            padding: 6px;
            border-radius: 6px;
            background: #f9f9f9;
            display: block;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(51, 51, 51, 1);

            p {
                & + p {
                    margin-top: 8px;
                }
            }
        }
    }
    .file_upload_wrap {
        height: auto;
        .upload_file_list {
            padding: 0;
        }
    }
}
</style>
<style lang="scss">
.van-image-preview__overlay {
    background: rgba(0, 0, 0, 0.3);
}

.van-image-preview {
    .van-image-preview__index {
        top: auto;
        bottom: 26px !important;
        text-shadow: none;
    }
}
</style>
